import { parseKioskOsInfo } from "./parse_kiosk_os_info.js";
import _ from "underscore";
import { ApiHeader, BiteProject, ClientType, KioskOs, isValidEnumValue } from "@biteinc/enums";
//#region src/a_context.ts
var AContext = class {
	reqId;
	apiVersion;
	gcnBuildName;
	garconBuildName;
	vitrineBuildName;
	kioskBuild;
	kioskOs;
	kioskOsVersion;
	accessUser;
	sessionUser;
	/** The Bite user behind an impersonation session; `sessionUser` is the impersonated user. */
	impersonator;
	kiosk;
	menu;
	location;
	org;
	clientOrderChannel;
	orderId;
	clientOrderId;
	isIosKiosk() {
		return this.kioskOs === "iOS";
	}
	getClientType() {
		if (!this.sessionUser) throw new Error("Cannot determine client type without session user");
		if (this.sessionUser.isFlash()) return ClientType.Flash;
		if (this.originalBiteServiceName === BiteProject.Bureau) return ClientType.KioskPreview;
		return ClientType.Kiosk;
	}
	getClientDescription(clientType = this.getClientType()) {
		switch (clientType) {
			case ClientType.Kiosk:
				if (this.kiosk) return `Kiosk ${this.kiosk.displayName()}`;
				if (this.sessionUser) return `User ${this.sessionUser.data.username}`;
				return `Unknown User`;
			case ClientType.KioskPreview: return "Kiosk Preview Client";
			case ClientType.Flash: return "Flash Client";
		}
	}
	setAccessUser(accessUser) {
		this.accessUser = accessUser;
	}
	setOrderId(orderId) {
		this.orderId = orderId;
		return this;
	}
	setClientOrderId(clientOrderId) {
		this.clientOrderId = clientOrderId;
		return this;
	}
	setKiosk(kiosk) {
		this.kiosk = kiosk;
		return this;
	}
	setLocation(location) {
		this.location = location;
		return this;
	}
	setMenu(menu) {
		this.menu = menu;
		return this;
	}
	setSessionUser(sessionUser) {
		this.sessionUser = sessionUser;
		return this;
	}
	getContextSummary() {
		if (this.menu) return {
			orgId: this.menu.data.orgId,
			locationId: this.menu.data.locationId,
			menuId: this.menu.id
		};
		if (this.location) return {
			orgId: this.location.data.orgId,
			locationId: this.location.id
		};
		if (this.org) return { orgId: this.org.id };
		return {};
	}
	toJSON() {
		const json = _.omit(this, (value) => {
			return _.isUndefined(value);
		});
		if (this.org) json.org = `${this.org.data.name} (${this.org.id})`;
		if (this.location) json.location = `${this.location.data.name} (${this.location.id})`;
		if (this.menu) json.menu = `${this.menu.id}`;
		if (this.kiosk) json.kiosk = `${this.kiosk.displayName()} (${this.kiosk.id})`;
		if (this.sessionUser) json.sessionUser = `${this.sessionUser.data.username} (${this.sessionUser.id})`;
		if (this.accessUser) json.accessUser = `${this.accessUser.data.username} (${this.accessUser.id})`;
		if (this.impersonator) json.impersonator = `${this.impersonator.data.username} (${this.impersonator.id})`;
		return json;
	}
};
function setContextFieldsFromHeaders(ctx, headers) {
	const apiVersion = parseInt(headers[ApiHeader.ApiVersion], 10);
	ctx.apiVersion = Number.isInteger(apiVersion) ? apiVersion : 0;
	ctx.userAgent = headers["user-agent"] || "";
	ctx.referer = headers.referer || "";
	if (isValidEnumValue(BiteProject, headers[ApiHeader.BiteServiceName])) ctx.originalBiteServiceName = headers[ApiHeader.BiteServiceName];
	const kioskBuildName = headers[ApiHeader.KioskBuildName];
	const kioskOS = headers[ApiHeader.KioskOs];
	if (kioskBuildName) ctx.kioskBuild = kioskBuildName;
	if (ctx.kioskBuild) {
		const iOSMatches = ctx.userAgent.match(/iOS [0-9]{1,2}(\.[0-9]{1,2})+/);
		if (iOSMatches && _.size(iOSMatches) >= 2) {
			ctx.kioskOs = KioskOs.iOS;
			ctx.kioskOsVersion = iOSMatches[0].substring(4);
		}
		const osInfo = parseKioskOsInfo(ctx.userAgent, kioskOS);
		if (osInfo) {
			ctx.kioskOs = osInfo.os;
			ctx.kioskOsVersion = osInfo.osVersion;
		}
	}
	ctx.vitrineBuildName = headers[ApiHeader.VitrineBuildName];
	ctx.gcnBuildName = headers[ApiHeader.GcnBuildName];
	ctx.garconBuildName = headers[ApiHeader.GarconBuildName];
}
//#endregion
export { AContext, setContextFieldsFromHeaders };

//# sourceMappingURL=a_context.js.map